import { colors } from '@shared/tokens/colors.stylex';
import { FC } from 'react';

interface DownloadLinksIconProps {
  color?: string;
  size?: number;
}

export const DownloadLinksIcon: FC<DownloadLinksIconProps> = ({ color = colors.primaryIcon, size = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-label="download links icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.5C8.27614 1.5 8.5 1.72386 8.5 2V9.79289L10.6464 7.64645C10.8417 7.45118 11.1583 7.45118 11.3536 7.64645C11.5488 7.84171 11.5488 8.15829 11.3536 8.35355L8.35355 11.3536C8.15829 11.5488 7.84171 11.5488 7.64645 11.3536L4.64645 8.35355C4.45118 8.15829 4.45118 7.84171 4.64645 7.64645C4.84171 7.45118 5.15829 7.45118 5.35355 7.64645L7.5 9.79289V2C7.5 1.72386 7.72386 1.5 8 1.5ZM2 10.5C2.27614 10.5 2.5 10.7239 2.5 11V12.5C2.5 13.0523 2.94772 13.5 3.5 13.5H12.5C13.0523 13.5 13.5 13.0523 13.5 12.5V11C13.5 10.7239 13.7239 10.5 14 10.5C14.2761 10.5 14.5 10.7239 14.5 11V12.5C14.5 13.6046 13.6046 14.5 12.5 14.5H3.5C2.39543 14.5 1.5 13.6046 1.5 12.5V11C1.5 10.7239 1.72386 10.5 2 10.5Z"
        fill={color}
      />
    </svg>
  );
};
